<template>
    <div class="InvoiceNumber">
        <van-radio-group v-model="deliveryWay" >
        <van-cell-group>
            <van-cell title="到店自取" clickable @click="radio = '1'">
            <van-radio slot="right-icon" name="1" />
            </van-cell>
            <van-cell title="邮寄到家" clickable @click="radio = '2'">
            <van-radio slot="right-icon" name="2" />
            </van-cell>
        </van-cell-group>
        </van-radio-group>
            <van-field
                v-model="invoiceKind"
                clearable
                label-width= 90
                label="抬头"
                size="medium"
                readonly
                @click="setReason()"
                class="inputVant border-top"
            />
            <van-field
                v-model="orderNumber"
                clearable
                label-width= 90
                label="纳税人识别号"
                size="medium"
                class="inputVant"
            />
            <van-field
                v-model="openingBank"
                clearable
                label-width= 90
                label="开户银行"
                size="medium"
                class="inputVant"
            />
            <van-field
                v-model="account"
                clearable
                label-width= 90
                label="银行卡号"
                size="medium"
                class="inputVant"
            />
            <van-field
                v-model="deliveryAddress"
                clearable
                label-width= 90
                label="收货地址"
                size="medium"
                class="inputVant"
                v-if="deliveryWay == 2"
            />
        <van-popup
        v-model="reasonShow"
        position="bottom"
        
        >
            <van-picker
            show-toolbar
            :columns="reasonsName"
            @cancel="reasHidePicker"
            @confirm="reasConfirms" 
            />
        </van-popup>
        <div class="Submission" @click="submit()">提 交</div>        
    </div>
</template>
<script>
import { Field, CellGroup, DatetimePicker, Uploader, Notify, Cell,  RadioGroup, Radio, Picker, Popup  } from 'vant';
import { addInvoice } from '@/api/index';
export default {
    components:{
        [Field.name] : Field,
        [CellGroup.name] : CellGroup,
        [DatetimePicker.name] : DatetimePicker,
        [Uploader.name] : Uploader,
        [Notify.name] : Notify,
        [Cell.name] : Cell,
        [RadioGroup.name] : RadioGroup,
        [Radio.name] : Radio,
        [Picker.name] : Picker,
        [Popup.name] : Popup
    },
    data(){
        return {
            deliveryWay: 1,
            invoiceKind: '',
            orderNumber: '',
            openingBank:'',
            deliveryAddress: '',
            reasonShow: false,
            reasonsName:['个人','单位'],
            account: '',
            invoiceHeader: 0

        }
    },
    methods:{
        setReason(){
            this.reasonShow = true;
        },
        /**
         * 选择报修关闭回调
         */
        reasHidePicker(){
            this.reasonShow = false
        },
        /**
         * 选择报销确定change
         */
        reasConfirms(value, i){
            this.invoiceHeader = i + 1;
            this.reasonShow = false;
            console.log(value, i)
        },
        submit(){
            let data = {
                account : this.account,
                deliveryAddress: this.deliveryAddress,
                deliveryWay: this.deliveryWay,
                invoiceHeader: this.invoiceHeader,
                openingBank: this.openingBank,
                phone: this.$loca.getItem('phone'),
                name: this.$loca.getItem('name')
                
            }
            addInvoice(data).then(res=>{
                this.$routr.push({path:'/'});
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.InvoiceNumber{
    width: 100vw;
    height: 100%;
    position: relative;
    background-color: #f6f6f6;
    .content{
        background: #ffffff;
        padding: 0 33px 0 43px;
        .inputVant{
            line-height: 71px;
            align-items:center;
        }
        .textareaVant{
            padding-top: 20px;
            line-height: 34px;
        }
    } 
    .pickerModel{
        position: fixed;
        bottom: 0;
        width: 100vw;
    }
    .imgList{
        background: #ffffff;
        padding: 20px 33px 20px 43px;
        border-top:1px solid  #f6f6f6;
        .imgTitle{
            margin-left: 14px;
            margin-right: 20px; 
        }
    }
    .Submission{
        margin: 40px 20px 0 20px;
        height:82px;
        background:rgba(248,169,31,1);
        border-radius:15px;
        color: rgba(254, 254, 254, 1);
        font-size:36px;
        line-height: 82px;
        text-align: center;
    }
}
.inputVant{
    line-height: 51px;
    align-items:center;
    position: relative;
}
.border-top{
    border-top: 1px solid #ebedf0;
}
</style>